import { DefaultLink } from '@hivebrite/design-system/Link';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

const LoginButton = ({ children }) => {
  const { topicId, networkRootUrl } = useTopicContext();

  return (
    <DefaultLink
      className="button custom-color-login-button custom-bg-color-login-button"
      href={`${networkRootUrl}/login?redirect_to=${encodeURIComponent(
        Routes.topic_path(topicId),
      )}`}
    >
      {children}
    </DefaultLink>
  );
};

const Login = ({ restrictedAccess }) => (
  <div className="grid grid--full grid--center">
    <div className="grid__item two-thirds palm--one-whole">
      <div className="bg-white bordered palm--border-none soft">
        <div className="soft--bottom text--center">
          {restrictedAccess && <i className="icon-lock icon-size--300" />}
          <div className="push-half--top">
            {restrictedAccess ? (
              <div data-testid="private group display">
                <h4 className="h4 push-quarter--bottom">
                  {I18n.t('web.topics.member_requests.restricted_access_msg_1')}
                </h4>
                {__('Please login to see it')}
              </div>
            ) : (
              <h4
                data-testid="public group display"
                className="h4 push-quarter--bottom"
              >
                {__('Please login to see it')}
              </h4>
            )}
            <div className="push--top">
              <LoginButton>
                {I18n.t('layouts.homepage_network.header.login')}
              </LoginButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Login;
